module.exports = __webpack_public_path__ + "static/media/northern-blue.06c1a83f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/silver-aluminum-case/northern-blue.jpeg
// module id = 2100
// module chunks = 0